import { defineRouteDef, z } from '@/domains/common/api';

// Multipart audio upload — body schema omitted; handler reads formData.
export const transcribeAudioRoute = defineRouteDef({
  method: 'POST',
  path: '/api/chat/transcribe',
  audience: 'user',
  output: z.object({ text: z.string() }),
});
